import * as watchers from './promo-code-watchers'
import { fork } from 'redux-saga/effects'

export default [
  fork(watchers.watchPromoCodeLoadPage),
  fork(watchers.watchPromoCodeEdit),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/promo-code/index.js
 **/